module.exports = __webpack_public_path__ + "static/media/harpoparrot.82f2d311.gif";